module.exports = __webpack_public_path__ + "img/homeimage.efab7095.jpg";